import { MemberTransactionType } from '@types';

export const getDownloadReceiptDetails = (
  memberDetails: Pick<
    MemberTransactionType,
    'id' | 'is_split_payment' | 'split_payment_order_id' | 'total_paid_amount'
  >,
  fallbackSplitPaymentOrderId?: string
) => {
  const isSplitPayment =
    memberDetails.is_split_payment && memberDetails.total_paid_amount !== '0';
  const splitPaymentOrderId =
    memberDetails.split_payment_order_id || fallbackSplitPaymentOrderId;

  return {
    downloadReciptId:
      isSplitPayment && splitPaymentOrderId
        ? splitPaymentOrderId
        : memberDetails.id,
    isSplitPayment
  };
};

export const isNonZero = (n: number) => Math.abs(Number(n)) > 1e-9;
